import React from 'react'

export type Attachment = {
  name: string
  imgUrl: string
  accessUrl: string
  backupImgUrl: string
}

export type AttachmentProps = {
  attachment: Attachment
  className?: string
}

/**
 * Component to display an attachment with a thumbnail image and a link to access it.
 * @param {Attachment} attachment - The attachment object containing the name, image URL, and access URL.
 * @param {string} className - Additional class names for styling.
 */
export const Attachment: React.FC<AttachmentProps> = ({ attachment, className }) => {
  const [useBackup, setUseBackup] = React.useState(false)

  return (
    <div className={`relative h-20 min-h-20 w-20 min-w-20 border border-gray-200 bg-gray-400/40 ${className || ''}`}>
      <img
        src={useBackup ? attachment.backupImgUrl : attachment.imgUrl}
        onError={() => setUseBackup(true)}
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="flex-sm absolute inset-0 z-10 flex items-center justify-center overflow-hidden break-all bg-white/30 px-2 text-xs font-bold opacity-0 hover:opacity-100">
        <a target="_blank" href={attachment.accessUrl} className="hover:text-link">
          {attachment.name}
        </a>
      </div>
    </div>
  )
}
